import React, { useState, useEffect } from "react";
import SurveyQuestionViewModal from "../../../modals/admin/survey/SurveyQuestionViewModal";
import { getRequest } from "../../../services";

const ListSurvey = () => {
    const [isQuestionViewModalOpen, setIsQuestionViewModalOpen] = useState(false);
    const [selectedSurvey, setSelectedSurvey] = useState(null);
    const [surveys, setSurveys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("parent");
    const [searchTerm, setSearchTerm] = useState("");

    const audienceTypes = [
        { key: "parent", label: "Parent" },
        { key: "student", label: "Student" },
        { key: "teacher", label: "Teacher" }
    ];

    const fetchSurveys = async (audienceType) => {
        setLoading(true);
        try {
            const response = await getRequest(`/api/Survey/survey-by-audience?type=${audienceType}`);
            if (response && response.data) {
                setSurveys(response.data);
            }
        } catch (error) {
            console.error("Error fetching surveys:", error);
            setSurveys([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSurveys(activeTab);
    }, [activeTab]);

    const handleViewReport = async (survey) => {
        try {
            const response = await getRequest(`/api/Survey/responses/${survey.id}`);
            if (response && response.data) {
                setSelectedSurvey({
                    ...survey,
                    responses: response.data
                });
                setIsQuestionViewModalOpen(true);
            }
        } catch (error) {
            console.error("Error fetching survey responses:", error);
        }
    };

    const handleQuestionViewModalClose = () => {
        setIsQuestionViewModalOpen(false);
        setSelectedSurvey(null);
    };

    const filteredSurveys = surveys.filter(survey =>
        survey.surveyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        survey.objective?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div>
            {/* Tabs */}
            <div className="flex space-x-1 mb-4">
                {audienceTypes.map((type) => (
                    <button
                        key={type.key}
                        onClick={() => setActiveTab(type.key)}
                        className={`px-4 py-2 rounded-t-lg font-medium ${
                            activeTab === type.key
                                ? "bg-[#241763] text-white"
                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                        }`}
                    >
                        {type.label}
                    </button>
                ))}
            </div>

            {/* Search */}
            <div className="flex w-full items-center justify-between mt-4 space-x-2">
                <input
                    type="text"
                    placeholder="Search surveys..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="border border-gray-300 rounded p-2 w-5/6"
                />
            </div>

            {/* Table */}
            <div className="overflow-x-auto mt-6">
                <table className="table-auto w-full mt-6">
                    <thead className="py-4 border-b font-bold">
                        <tr className="bg-gray-100 border-b">
                            <th className="p-3">Survey Name</th>
                            <th className="p-3">Objective</th>
                            <th className="p-3">Survey Type</th>
                            <th className="p-3">Audience</th>
                            <th className="p-3">Survey Report</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm">
                        {loading ? (
                            <tr>
                                <td colSpan="5" className="text-center p-4">
                                    Loading...
                                </td>
                            </tr>
                        ) : filteredSurveys.length > 0 ? (
                            filteredSurveys.map((survey, index) => (
                                <tr key={survey.id || index} className="hover:bg-gray-200 border-b">
                                    <td className="p-3">{survey.surveyName}</td>
                                    <td className="p-3 max-w-xs truncate" title={survey.objective}>
                                        {survey.objective}
                                    </td>
                                    <td className="p-3">{survey.surveyType}</td>
                                    <td className="p-3">{survey.audience}</td>
                                    <td className="p-3">
                                        <button 
                                            className="bg-[#241763] text-white px-3 py-1 rounded hover:bg-[#241763]/80"
                                            onClick={() => handleViewReport(survey)}
                                        >
                                            View Report
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center p-4">
                                    No Surveys Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <SurveyQuestionViewModal
                isOpen={isQuestionViewModalOpen}
                onClose={handleQuestionViewModalClose}
                survey={selectedSurvey}
            />
        </div>
    );
};

export default ListSurvey;
